import L from "leaflet";
import "leaflet-routing-machine";
import "leaflet/dist/leaflet.css"; // Import leaflet CSS
import ReactDOMServer from "react-dom/server";
import { IoCarSharp } from "react-icons/io5";
import { useEffect, useState, useCallback, useRef } from "react";
import { memo } from "react";

const MapComponent = ({ booking, status, driverPosition }) => {
  const [driverArrivalTime, setDriverArrivalTime] = useState(null);
  //For leaflet map
  const mapRef = useRef(null);
  const mapContainerRef = useRef(null);
  const routingControlRef = useRef(null);
  const driverMarkerRef = useRef(null); // Track the driver's marker

  const initializeMap = useCallback(() => {
    if (mapContainerRef.current && !mapRef.current) {
      mapRef.current = L.map(mapContainerRef.current).setView(
        [driverPosition.latitude, driverPosition.longitude],
        13
      );

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(mapRef.current);
    }
  }, [driverPosition]);


  const updateMap = useCallback(() => {
    if (!mapRef.current || !driverPosition || !booking?.pickupLocation) return;
  
    const map = mapRef.current;
  
    // Clear previous driver marker if it exists
    if (driverMarkerRef.current) {
      map.removeLayer(driverMarkerRef.current);
    }
  
    map.panTo([driverPosition.latitude, driverPosition.longitude]);
  
    const customIcon2 = L.divIcon({
      html: ReactDOMServer.renderToString(
        <IoCarSharp size={42} color="green" />
      ),
      className: "custom-icon",
      iconSize: [42, 42],
      iconAnchor: [21, 42],
    });
  
    driverMarkerRef.current = L.marker(
      [driverPosition.latitude, driverPosition.longitude],
      {
        icon: customIcon2,
      }
    ).addTo(map);
  
    if (routingControlRef.current) {
      routingControlRef.current.getPlan().setWaypoints([]); // Clear waypoints
      map.removeControl(routingControlRef.current); // Remove control
      routingControlRef.current = null;
    }
  
    if (status === "ONGOING") {
      routingControlRef.current = L.Routing.control({
        waypoints: [
          L.latLng(driverPosition.latitude, driverPosition.longitude),
          L.latLng(
            booking.pickupLocation.coordinates[1],
            booking.pickupLocation.coordinates[0]
          ),
        ],
        router: new L.Routing.OSRMv1({
          serviceUrl: "https://router.project-osrm.org/route/v1",
        }),
        routeWhileDragging: false,
        createMarker: () => null, // No markers at waypoints
        formatter: new L.Routing.Formatter({
          language: 'en',
          units: 'imperial', // Use imperial units for miles
          roundingSensitivity: 0.1, // Adjust sensitivity for rounding
        }),
      })
        .on("routesfound", function (e) {
          const routes = e.routes;
          if (routes && routes.length > 0) {
            const route = routes[0];
            const eta = route.summary.totalTime; // Time in seconds
            const distanceInMeters = route.summary.totalDistance; // Distance in meters
            const distanceInMiles = (distanceInMeters / 1609.34).toFixed(2); // Convert to miles
  
            setDriverArrivalTime({
              eta: Math.round(eta / 60), // ETA in minutes
              distance: distanceInMiles, // Distance in miles
            });
          }
        })
        .on("routingerror", (error) => {
          console.error("Routing error:", error);
        })
        .addTo(map);
    }
  }, [booking?.pickupLocation, driverPosition, status]);

  useEffect(() => {
    initializeMap();
  }, [initializeMap]);

  useEffect(() => {
    if (status === "ONGOING" || status === "ARRIVED") {
      updateMap();
    }
  }, [updateMap, status, driverPosition]);

  if ((status !== "ONGOING" && status !== "ARRIVED") || !driverPosition)
    return null;

  return (
    <div>
      <div
        ref={mapContainerRef}
        style={{ height: "400px", width: "100%" }}
      ></div>

      {status === "ONGOING" && (
         <div>
         <h3>Approximated Reach Time: {driverArrivalTime?.eta} minutes</h3>
         <h4>Distance to Pickup: {driverArrivalTime?.distance} miles</h4>
       </div>
      )}
    </div>
  );
};

export default memo(MapComponent);
